import { SimulatedDebt, SimulatedPaymentOption } from '@common/apis/simulated-debt/types';

const INSTALLMENT_WITHOUT_DISCOUNT_PROP = 'INSTALLMENT_VALUE_WITHOUT_DISCOUNT';

export function isDesenrolaBradesco(debt?: SimulatedDebt): boolean {
  const id = debt?.partner?.identifier || '';
  const isBradesco = id.includes('bradesco');
  const isDesenrola = !!debt?.propriedades?.some((p) => p.chave === 'IS_DESENROLA' && p.valorBoolean === true);
  return isBradesco && isDesenrola;
}

export function getPaymentOptiontOverdueInstallmentValue(paymentOption: SimulatedPaymentOption) {
  const safeProps = paymentOption?.propriedades || [];
  const usedProp = safeProps.find((prop) => prop.chave === INSTALLMENT_WITHOUT_DISCOUNT_PROP);
  if (usedProp) return usedProp.valorDecimal;
}
